<template>
    <div class="row position-relative" style="margin-top: 55px;">
        <div class="bg-computer">
            <div class="row container my-5 py-3">
                <div class="col-2"></div>
                <div class="col-md-5 text-end pe-5">
                    <h3 class="fw-bold my-4">خدمات مدیریت و تحلیل داده</h3>
                    <button class="btn-blue mt-5">ثبت نام رایگان</button>
                </div>
                <div class="col-md-5 text-start">
                    <img src="../../assets/services-img/computer.png" width="85%" alt="">
                </div>
            </div>
        </div>
    </div>
    <div class="container">
        <div class="row col-lg-9 mx-auto px-0">
            <div class="my-5">
                <div class="row px-0 mx-0 mt-5 pt-5">
                    <h3 class="fw-bold">تحول داده محور برای تصمیم‌گیری بهتر و رشد کسب‌وکار</h3>
                    <h5 class="mt-3 ps-3" style="line-height: 30px;">
                        در دنیای دیجیتال امروزی، داده‌ها ارزشمندترین دارایی هر کسب‌وکاری هستند. مدیریت و تحلیل صحیح داده‌ها می‌تواند به سازمان‌ها کمک کند تا تصمیمات هوشمندانه‌تری بگیرند، فرآیندهای خود را بهینه کنند و فرصت‌های جدیدی برای رشد ایجاد نمایند. ما با ارائه راهکارهای نوین در مدیریت داده، تحلیل پیشرفته و هوش تجاری، به شما کمک می‌کنیم تا داده‌ها را به بینش و استراتژی‌های مؤثر تبدیل کنید.
                    </h5>
                </div>
            </div>
            <div class="my-5">
                <div class="row px-0 mx-0">
                    <div class="text-end">
                        <h4 class="fw-bold">چالش‌های مدیریت و تحلیل داده در سازمان‌ها</h4>
                        <h6 class="mt-3 ps-3" style="line-height: 30px;">
                            <ul>
                                <li>
                                    <strong>حجم بالای داده‌های خام بدون ساختار:</strong> بسیاری از سازمان‌ها حجم زیادی از داده‌های غیرسازمان‌یافته دارند که تحلیل آن‌ها دشوار است.
                                </li>
                                <li class="mt-3">
                                    <strong>عدم وجود استراتژی داده‌محور:</strong> نبود یک برنامه مشخص برای جمع‌آوری، پردازش و استفاده از داده‌ها باعث هدررفت اطلاعات ارزشمند می‌شود.
                                </li>
                                <li class="mt-3">
                                    <strong>چالش‌های امنیتی و حفاظت از داده‌ها:</strong> تهدیدات سایبری و نقض حریم خصوصی می‌توانند به اطلاعات حساس سازمان آسیب برسانند.
                                </li>
                                <li class="mt-3">
                                    <strong>مشکل در تجزیه‌وتحلیل داده‌ها برای تصمیم‌گیری سریع:</strong> نبود ابزارهای مناسب تحلیل داده، سازمان‌ها را از تصمیم‌گیری هوشمندانه بازمی‌دارد.
                                </li>
                                <li class="mt-3">
                                    <strong>عدم یکپارچگی داده‌ها در بخش‌های مختلف سازمان:</strong> وجود داده‌های پراکنده در سیستم‌های مختلف باعث کاهش بهره‌وری و دقت تحلیل‌ها می‌شود.
                                </li>
                            </ul>
                        </h6>
                    </div>
                </div>
            </div>
            <div class="my-5">
                <h3 class="fw-bold">راهکارهای ما برای مدیریت و تحلیل داده</h3>
                <div class="row px-0 mx-0 mt-5">
                    <div class="col-md-7 text-end">
                        <h4 class="fw-bold mt-5">طراحی و پیاده‌سازی استراتژی مدیریت داده</h4>
                        <h6 class="mt-3 ps-3" style="line-height: 30px;">
                            <ul>
                                <li>تدوین نقشه راه داده‌محور برای سازمان</li>
                                <li>ایجاد فرآیندهای جمع‌آوری، ذخیره‌سازی و پردازش داده‌ها</li>
                                <li>بهینه‌سازی کیفیت و استانداردسازی داده‌ها</li>
                            </ul>
                        </h6>
                    </div>
                    <div class="col-md-5 my-auto text-start">
                        <img src="../../assets/services-img/img22.svg" class="w-100" alt="">
                    </div>
                </div>
            </div>
            <div class="my-5">
                <div class="row px-0 mx-0">
                    <div class="col-md-5 my-auto text-end d-md-block d-none">
                        <img src="../../assets/services-img/img6.svg" class="w-100" alt="">
                    </div>
                    <div class="col-md-7 text-end mt-5">
                        <h4 class="fw-bold mt-5">تحلیل داده‌های کسب‌وکار و هوش تجاری (BI)</h4>
                        <h6 class="mt-3 ps-3" style="line-height: 30px;">
                            <ul>
                                <li>استفاده از داشبوردهای تحلیلی برای ارائه گزارش‌های دقیق</li>
                                <li>تحلیل روندهای بازار و پیش‌بینی رفتار مشتریان</li>
                                <li>یکپارچه‌سازی داده‌ها برای تصمیم‌گیری مبتنی بر اطلاعات واقعی</li>
                            </ul>    
                        </h6>
                    </div>
                    <div class="col-md-5 my-auto text-end d-md-none d-block">
                        <img src="../../assets/services-img/img6.svg" class="w-100" alt="">
                    </div>
                </div>
            </div>
            <div class="my-5">
                <div class="row px-0 mx-0 mt-5">
                    <div class="col-md-7 text-end">
                        <h4 class="fw-bold mt-5">پردازش و تجزیه‌وتحلیل داده‌های بزرگ (Big Data)</h4>
                        <h6 class="mt-3 ps-3" style="line-height: 30px;">
                            <ul>
                                <li>استفاده از فناوری‌های پردازش کلان‌داده برای استخراج بینش‌های ارزشمند</li>
                                <li>تحلیل داده‌های ساختاریافته و غیرساختاریافته برای بهینه‌سازی عملکرد</li>
                                <li>پیاده‌سازی راهکارهای پیشرفته برای ذخیره و پردازش حجم بالای داده</li>
                            </ul>  
                        </h6>
                    </div>
                    <div class="col-md-5 my-auto text-start">
                        <img src="../../assets/services-img/img2.svg" class="w-100" alt="">
                    </div>
                </div>
            </div>
            <div class="my-5">
                <div class="row px-0 mx-0">
                    <div class="col-md-5 my-auto text-end d-md-block d-none">
                        <img src="../../assets/services-img/img4.svg" class="w-100" alt="">
                    </div>
                    <div class="col-md-7 text-end mt-5">
                        <h4 class="fw-bold mt-5">راهکارهای داده‌محور برای بهینه‌سازی فرآیندهای سازمانی</h4>
                        <h6 class="mt-3 ps-3" style="line-height: 30px;">
                            <ul>
                                <li>تحلیل عملکرد کسب‌وکار و بهینه‌سازی فرآیندها</li>
                                <li>استفاده از داده‌ها برای بهبود تجربه مشتری و افزایش وفاداری</li>
                                <li>ایجاد مدل‌های پیش‌بینی برای مدیریت ریسک و تصمیم‌گیری سریع</li>
                            </ul>  
                        </h6>
                    </div>
                    <div class="col-md-5 my-auto text-end d-md-none d-block">
                        <img src="../../assets/services-img/img4.svg" class="w-100" alt="">
                    </div>
                </div>
            </div>
            <div class="my-5">
                <div class="row px-0 mx-0 mt-5">
                    <div class="col-md-7 text-end">
                        <h4 class="fw-bold mt-5">پیاده‌سازی هوش مصنوعی و یادگیری ماشین در تحلیل داده‌ها</h4>
                        <h6 class="mt-3 ps-3" style="line-height: 30px;">
                            <ul>
                                <li>استفاده از الگوریتم‌های یادگیری ماشین برای شناسایی الگوها و پیش‌بینی روندها</li>
                                <li>تحلیل رفتار مشتریان و ارائه پیشنهادهای شخصی‌سازی‌شده</li>
                                <li>طراحی مدل‌های پیش‌بینی برای افزایش بهره‌وری و کاهش هزینه‌ها</li>
                            </ul>  
                        </h6>
                    </div>
                    <div class="col-md-5 my-auto text-start">
                        <img src="../../assets/services-img/img1.svg" class="w-100" alt="">
                    </div>
                </div>
            </div>
            <div class="my-5">
                <div class="row px-0 mx-0">
                    <div class="col-md-5 my-auto text-end d-md-block d-none">
                        <img src="../../assets/services-img/img7.svg" class="w-100" alt="">
                    </div>
                    <div class="col-md-7 text-end mt-5">
                        <h4 class="fw-bold mt-5">امنیت و حاکمیت داده</h4>
                        <h6 class="mt-3 ps-3" style="line-height: 30px;">
                            <ul>
                                <li>پیاده‌سازی راهکارهای امنیتی برای حفاظت از داده‌ها</li>
                                <li>ایجاد سیاست‌های حاکمیت داده برای کنترل دسترسی و رعایت الزامات قانونی</li>
                                <li>بررسی و مدیریت ریسک‌های مرتبط با ذخیره و انتقال داده‌ها</li>
                            </ul>  
                        </h6>
                    </div>
                    <div class="col-md-5 my-auto text-end d-md-none d-block">
                        <img src="../../assets/services-img/Logistics.svg" class="w-100" alt="">
                    </div>
                </div>
            </div>
            <div class="my-5">
                <div class="row px-0 mx-0 mt-5">
                    <div class="col-md-7 text-end">
                        <h4 class="fw-bold mt-5">یکپارچه‌سازی داده‌ها و ایجاد زیرساخت‌های داده‌ای پیشرفته</h4>
                        <h6 class="mt-3 ps-3" style="line-height: 30px;">
                            <ul>
                                <li>طراحی و پیاده‌سازی پایگاه‌های داده پیشرفته</li>
                                <li>ایجاد زیرساخت‌های داده‌ای برای اتصال و یکپارچه‌سازی سیستم‌های مختلف</li>
                                <li>بهینه‌سازی فرآیندهای انتقال داده و کاهش هزینه‌های ذخیره‌سازی</li>
                            </ul>  
                        </h6>
                    </div>
                    <div class="col-md-5 my-auto text-start">
                        <img src="../../assets/services-img/img23.svg" class="w-100" alt="">
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row position-relative">
        <div class="bg-computer" style="border-top-right-radius: 40px; padding-left: 200px;">
            <div class="container my-5 py-3">
                <h3 class="my-5 text-end">نتایج و ارزش‌آفرینی برای سازمان‌ها</h3>
                <div class="row">
                    <div class="col-lg-3 col-md-6 d-flex">
                        <div class="card-hover">
                            <div>
                                <img src="../../assets/services-img/img14.svg" class="w-75" alt="">
                            </div>
                            <div class="mt-3 ps-3" style="line-height: 30px;font-size: 14px;">
                                <strong>افزایش دقت در تصمیم‌گیری‌های کسب‌وکار </strong> با تحلیل‌های داده‌محور 
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 d-flex">
                        <div class="card-hover">
                            <div>
                                <img src="../../assets/services-img/img4.svg" class="w-75" alt="">
                            </div>
                            <div class="mt-3 ps-3" style="line-height: 30px;font-size: 14px;">
                                <strong>بهبود کارایی سازمانی و کاهش هزینه‌ها </strong>با بهینه‌سازی فرآیندهای داده‌ای
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 d-lg-flex d-none">
                        <div class="card-hover">
                            <div>
                                <img src="../../assets/services-img/Secure.svg" class="w-75" alt="">
                            </div>
                            <div class="mt-3 ps-3" style="line-height: 30px;font-size: 14px;">
                                <strong>افزایش امنیت اطلاعات و کاهش ریسک‌های سایبری</strong> با پیاده‌سازی راهکارهای حفاظتی 
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-3 col-md-6 d-lg-none d-flex">
                        <div class="card-hover">
                            <div>
                                <img src="../../assets/services-img/Secure.svg" class="w-75" alt="">
                            </div>
                            <div class="mt-3 ps-3" style="line-height: 30px;font-size: 14px;">
                                <strong>افزایش امنیت اطلاعات و کاهش ریسک‌های سایبری</strong> با پیاده‌سازی راهکارهای حفاظتی 
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 d-flex">
                        <div class="card-hover">
                            <div>
                                <img src="../../assets/services-img/Running.svg" class="w-75" alt="">
                            </div>
                            <div class="mt-3 ps-3" style="line-height: 30px;font-size: 14px;">
                                <strong>ایجاد مزیت رقابتی و کشف فرصت‌های جدید</strong>با تحلیل داده‌های بازار 
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 d-flex">
                        <div class="card-hover">
                            <div>
                                <img src="../../assets/services-img/Business2.svg" class="w-75" alt="">
                            </div>
                            <div class="mt-3 ps-3" style="line-height: 30px;font-size: 14px;">
                                <strong>بهینه‌سازی تجربه مشتری و افزایش فروش</strong> با تحلیل دقیق رفتار مشتریان 
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <section class="container py-3">
        <div class="row col-md-9 mx-auto mt-5">
            <h3>سوالات متداول</h3>
            <div class="mx-auto my-5">
              <div class="accordion accordion-flush" id="accordionExample">
                <!-- 1: coll1 -->
                <div class="accordion-item">
                  <h2 class="accordion-header text-end">
                    <!--   data-bs-target="#coll1",  controls="coll1", id="coll1", aria-expanded="true"      -->
                    <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#coll1" aria-expanded="true" aria-controls="coll1">
                      <h6>چگونه می‌توانم داده‌های سازمان خود را به‌درستی مدیریت کنم؟</h6>
                    </button>
                  </h2>
                  <!-- show : by default Always open -->
                  <div id="coll1" class="accordion-collapse collapse show text-end" data-bs-parent="#accordionExample">
                    <div class="accordion-body text-end" style="line-height: 35px !important;">
                        ما با ارائه راهکارهای سفارشی در مدیریت داده، از جمع‌آوری تا پردازش و تحلیل، به شما کمک می‌کنیم تا داده‌های سازمانی خود را به‌درستی مدیریت کنید.                    </div>
                  </div>
                </div>

                <!-- 2: coll2 -->
                <div class="accordion-item">
                  <h2 class="accordion-header">
                    <!--       collapsed,   aria-expanded="false"   -->
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#coll2" aria-expanded="false" aria-controls="coll2">
                      <h6>آیا تحلیل داده برای کسب‌وکارهای کوچک نیز مفید است؟</h6>
                    </button>
                  </h2>
                  <div id="coll2" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                    <div class="accordion-body" style="line-height: 35px !important;">
                        بله، تحلیل داده می‌تواند به کسب‌وکارهای کوچک کمک کند تا تصمیم‌گیری‌های بهتری داشته باشند و از اطلاعات برای رشد و بهینه‌سازی استفاده کنند.                    </div>
                  </div>
                </div>

                <!-- 3: coll3 -->
                <div class="accordion-item">
                  <h2 class="accordion-header">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#coll3" aria-expanded="false" aria-controls="coll3">
                      <h6>چگونه می‌توانم از هوش مصنوعی برای تحلیل داده‌های کسب‌وکارم استفاده کنم؟</h6>
                    </button>
                  </h2>
                  <div id="coll3" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                    <div class="accordion-body" style="line-height: 35px !important;">
                        ما مدل‌های هوش مصنوعی و یادگیری ماشین را برای تحلیل الگوهای رفتاری، پیش‌بینی روندهای بازار و ارائه پیشنهادهای شخصی‌سازی‌شده پیاده‌سازی می‌کنیم.
                    </div>
                  </div>
                </div>

                <!-- 4: coll4 -->
                <div class="accordion-item">
                  <h2 class="accordion-header">
                    <!--   target="#coll4",  id="coll4"  -->
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#coll4" aria-expanded="false" aria-controls="coll4">
                      <h6>آیا خدمات شما شامل آموزش و پیاده‌سازی سیستم‌های داده‌محور نیز می‌شود؟</h6>
                    </button>
                  </h2>
                  <div id="coll4" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                    <div class="accordion-body" style="line-height: 35px !important;">
                        بله، ما علاوه بر ارائه مشاوره و تحلیل داده، در پیاده‌سازی و آموزش تیم‌های سازمانی نیز شما را همراهی می‌کنیم.
                    </div>
                  </div>
                </div>

                <!-- 5: coll5 -->
                <div class="accordion-item">
                  <h2 class="accordion-header">
                    <!--   target="#coll5",  id="coll5"  -->
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#coll5" aria-expanded="false" aria-controls="coll5">
                      <h6>چگونه می‌توانم امنیت داده‌های سازمان خود را افزایش دهم؟</h6>
                    </button>
                  </h2>
                  <div id="coll5" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                    <div class="accordion-body" style="line-height: 35px !important;">
                        ما با ارائه راهکارهای امنیت سایبری و حاکمیت داده، از اطلاعات شما در برابر تهدیدات محافظت می‌کنیم و سیاست‌های مدیریت داده را برای افزایش امنیت اجرا می‌کنیم.
                        <br>
                        مدیریت و تحلیل داده‌ها، کلید موفقیت در دنیای دیجیتال است. جهت دریافت مشاوره و اطلاعات بیشتر، با ما در تماس باشید.    
                    </div>
                  </div>
                </div>
              </div>
            </div>
        </div>
    </section>
</template>
<script>
import { defineComponent } from 'vue';
// import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faSlash } from "@fortawesome/free-solid-svg-icons";

 export default defineComponent({
    components:{},
    setup() {
        library.add(faSlash)

        return {

        }
    }
 })
</script>
<style lang="scss" scoped>
.faq-section .accordion-button h5 {
  /*   color: #7dbc9e; */
  color: #1838D2;
  margin-right: 13px;
}
.accordion-button:not(.collapsed) {
  /* background-color: #c5e5d8;*/
  background-color: #f7f7f7;
}

.accordion-button:not(.collapsed)::after {
  background-image: none;
  transform: none;
}

.accordion-button:focus {
  box-shadow: none;
  z-index: 1;
}

.accordion-button:before {
  content: "";
  position: absolute;
  /*   right: 0.75rem; */
  left: 0.75rem;
  top: 1.25rem;
  height: 2px;
  width: 1rem;
  background-color: #1838D2;
}
.accordion-button.collapsed:after {
  content: "";
  position: absolute;
  /*   right: 1.1875rem; */
  left: 1.1875rem;
  top: 0.8125rem;
  height: 1.0625rem;
  width: 0.125rem;
  border-style: none;
  background-color: #1838D2;
}

.faq-section .accordion-button h5 {
  /*   color: #7dbc9e; */
  color: #1838D2;
  margin-right: 13px;
}
.accordion-body {
  background-color: #f7f7f7;
  font-size: 14px !important;
  padding-left: 50px;
  padding-right: 30px;
  text-align: justify;
}
</style>